import { OrgAssociateCenter } from 'src/types';

export const filterOrgAssociateCenters = (
  searchQuery: string,
  assoicateCentersList: OrgAssociateCenter[]
): OrgAssociateCenter[] =>
  assoicateCentersList.filter((associateCenter) => {
    return (
      associateCenter.centerName
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase().trim()) ||
      associateCenter.centerNumber
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase().trim())
    );
  });
